import { Outlet } from "react-router-dom";
import FileHolder from "../FileHolder";

export default function FormLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
